export const FORMULARIO_RENTAS = "OBTENER_PUBLICACIONES";

export const OBTENER_RENTAS = "OBTENER_RENTAS";
export const AGREGAR_RENTA = "AGREGAR_RENTA";
export const VALIDAR_RENTA = "VALIDAR_RENTA";
export const ELIMINAR_RENTA = "ELIMINAR_RENTA";
export const RENTA_ACTUAL = "RENTA_ACTUAL";
export const SELECCIONAR_RENTA = "SELECCIONAR_RENTA";
export const ACTUALIZAR_RENTA = "ACTUALIZAR_RENTA";
export const LIMPIAR_RENTA = "LIMPIAR_RENTA";
export const OBTENER_RENTAS_TIPO = "OBTENER_RENTAS_TIPO";
export const OBTENER_RENTAS_USUARIO = "OBTENER_RENTAS_USUARIO";
export const PAUSAR_RENTA = "PAUSAR_RENTA";
export const OBTENER_IMAGENES_RENTA = "OBTENER_IMAGENES_RENTA";

//TYPES PARA AUTENTICACION

export const REGISTRO_EXITOSO = "REGISTRO_EXITOSO";
export const REGISTRO_ERROR = "REGISTRO_ERROR";
export const OBTENER_USUARIO = "OBTENER_USUARIO";
export const LOGIN_EXITOSO = "LOGIN_EXITOSO";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const CERRAR_SESION = "CERRAR_SESION";

//TYPES PARA LOS DATOS DE LAS RENTAS

export const HABITACION = "habitacion";
export const CASA = "casa";
export const DEPARTAMENTO = "departamento";

export const COMPARTIDO = "compartido";
export const PRIVADO = "privado";

export const MES = "mes";
export const BIMESTRE = "bimestre";
export const TRIMESTRE = "trimestre";
export const SEMESTRE = "semestre";
export const ANUAL = "anual";
export const SIN_CONTRATO = "sin contrato";

export const SIN_DEPOSITO = "sin deposito";
export const MEDIOMES_DEPOSITO = "medio mes";
export const MES_DEPOSITO = "un mes";

//TYPES PARA DATOS DE UNA PUBLICACIÓN DEL BAZAR

export const AGREGAR_BAZAR = "AGREGAR_BAZAR";
export const ELIMINAR_PRODUCTO_BAZAR = "ELIMINAR_PRODUCTO_BAZAR";
export const SELECCIONAR_PRODUCTO_BAZAR = "SELECCIONAR_PRODUCTO_BAZAR ";
export const LIMPIAR_PRODUCTO_BAZAR = " LIMPIAR_PRODUCTO_BAZAR";
export const OBTENER_PRODUCTOS_BAZAR = "OBTENER_PRODUCTOS_BAZAR ";
export const OBTENER_PRODUCTOS_CATEGORIA = "OBTENER_PRODUCTOS_CATEGORIA ";
export const PRODUCTO_BAZAR_ACTUAL = " PRODUCTO_BAZAR_ACTUAL";
export const VALIDAR_PRODUCTO = "VALIDAR_PRODUCTO ";
export const OBTENER_PRODUCTOS_BAZAR_USUARIO =
  "OBTENER_PRODUCTOS_BAZAR_USUARIO ";
export const PAUSAR_PRODUCTO = "PAUSAR_PRODUCTO";

//Estados de los articulos
export const NUEVO = "NUEVO";
export const SEMINUEVO = "COMO NUEVO";
export const BUEN_ESTADO = "BUEN ESTADO";
export const ACEPTABLE = "ACEPTABLE";
//Categorias de los articulos del bazar

export const MUEBLES = "MUEBLES";
export const ELECTRONICA = "ELECTRONICA";
export const ELECTRODOMESTICOS = "ELECTRODOMESTICOS";
export const MATERIAL_ESCOLAR = "MATERIAL ESCOLAR";
export const HOGAR = "HOGAR";

// ALERTAS
export const MOSTRAR_ALERTA = "MOSTRAR_ALERTA";

export const OCULTAR_ALERTA = "OCULTAR_ALERTA";
